import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chat-form-item" }

import {computed, getCurrentInstance, ref, watch} from 'vue';
import {ConfigStore} from "~/chat/ts/store/Config";
import MessageWrapper from "~/chat/ts/data/chat/MessageWrapper";
import {MESSAGE_HTML_PREFIX, QUESTION_CATEGORY_FIELD_NAME} from "~/chat/ts/Constants";
import ChatForm from "~/chat/vue/widget/form/ChatForm.vue";
import ChatFormButton from "~/chat/vue/widget/form/fields/ChatFormButton.vue";
import {CLIENT_DATA_TYPE_SELECT, CLIENT_DATA_TYPE_TEXTAREA} from "~/chat/ts/data/IClient";
import {COLLECT_CONTACT_FIELD_REQUIRED, PM_FORM_ACTION_AFTER_SEND_SHOW_MESSAGE} from "~/chat/ts/data/ISiteParams";
import Dictionary from "~/ts/library/Dictionary";
import {WidgetStore} from "~/chat/ts/store/Widget";
import {ChatTabStore} from "~/chat/ts/store/ChatTab";
import ChatApiRequest from "~/chat/ts/service/request/ChatApiRequest";
import IMessage from "~/chat/ts/data/chat/IMessage";
import MessageStorage from "~/chat/ts/service/messages/MessageStorage";
import MessageSender from "~/chat/ts/service/messages/MessageSender";
import {__} from "~/ts/library/Translate";
import AnalyticCounters from "~/chat/ts/service/AnalyticCounters";
import ApiCallback, {
    API_CALLBACK_CLIENT_SEND_MESSAGE,
    IApiCallbackClientSendMessagePayload
} from "~/chat/ts/service/api/methods/ApiCallback";
import ChatMessage from "~/chat/vue/widget/tabs/chat/ChatMessage.vue";
import {IField, IOption, ISelectField, ITextareaField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import {OperatorsStore} from "~/chat/ts/store/Operators";
import ChatTextareaInput from "~/chat/vue/widget/form/fields/ChatTextareaInput.vue";
import ChatAttachList from "~/chat/vue/widget/tabs/chat/ChatAttachList.vue";
import IChatUploadFile from "~/chat/vue/widget/form/IChatUploadFile";


const __default__ = {
    name: "OfflineFormTabContent"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const TEXTAREA_NAME = "text";
const OPERATOR_GROUP_NAME = "operatorsGroupId";


let model = ref<{
    form: Dictionary<any>,
    attachments: IChatUploadFile[]
}>({
    form: {
        [TEXTAREA_NAME]: null
    },
    attachments: []
});

function onUpload(files: IChatUploadFile[]) {
    model.value.attachments.push(...files);
}

let showLoad = ref(false);


let storageTextareaValue = ChatTabStore.textareaValue;

let hasChatHistory = computed(() => {
    return MessageStorage.messagesCount > 0;
});

let modelTextareaValue = computed<string>({
    get: () => {
        return model.value.form[TEXTAREA_NAME];
    },
    set: (value: string) => {
        model.value.form[TEXTAREA_NAME] = value;
    }

});


function syncTextareaFromStorage() {
    if (isNeedToSyncText()) {
        modelTextareaValue.value = storageTextareaValue.value;
    }
}


function isNeedToSyncText() {
    return storageTextareaValue.value != modelTextareaValue.value;
}

let leadGen = computed(() => {
    return ConfigStore.siteParams.value.params.leadGen;
});

function cancel() {
    ChatTabStore.toggleOfflineForm(false);
}

let visibleGroups = computed(() => {
    return OperatorsStore.groupList.value.filter(group => !group.hidden && !group.virtual);
});

let instance = getCurrentInstance().proxy;

async function send() {
    showLoad.value = true;
    try {
        let text = modelTextareaValue.value;
        let isFirstMessage = !ChatTabStore.isDialogRunning.value;


        let result = await ChatApiRequest.make({
            method: "sendLcabMetalk",
            p: {
                ...model.value.form,
                offlineFormAttachments: model.value.attachments.map(file => file.id),
                currentPage: {
                    url: window.location.href,
                    title: document.title
                },
                visibleOperatorGroupIds: visibleGroups.value.map(group => group.id)
            }
        });

        if (result.isSuccess()) {
            ChatTabStore.setTextareaValue(null);
            let message: IMessage = {
                id: result.getParam("id"),
                text,
                other: {
                    offline: true
                }
            };
            MessageSender.prepareNewMessage(message);

            //MessageStorage.saveMessage(message);
            MessageStorage.afterNewRealMessage(new MessageWrapper(message));

            let config = leadGen.value.pmForm;
            if (config.actionAfterSend == PM_FORM_ACTION_AFTER_SEND_SHOW_MESSAGE && config.textAfterSend) {
                WidgetStore.showModalMessage({
                    text: config.textAfterSend,
                    vue: instance
                });
            } else {
                cancel();
            }

            AnalyticCounters.send("Offline message sent", __("EVENT_SEND_TO_OFFLINE_FORM"));

            let payload: IApiCallbackClientSendMessagePayload = {
                text: message.text,
                firstMessage: isFirstMessage
            };
            ApiCallback.emit(API_CALLBACK_CLIENT_SEND_MESSAGE, payload);
        } else {
            result.showMessage(instance);
        }
    } catch (e) {
    }
    showLoad.value = false;

}

let message = computed(() => {
    let text = pmForm.value.text;
    text = text && text.trim().length ? text : null;
    let message: MessageWrapper;
    if (text) {
        message = new MessageWrapper({
            text: MESSAGE_HTML_PREFIX + text,
            from: "",
            isHideOperator: true
        });
    }
    return message;
});

let operatorGroupSelect = computed<ISelectField>(() => {
    if (OperatorsStore.isOfflineGroupSelectAllowed) {
        let operatorGroups = visibleGroups.value;

        if (operatorGroups.length) {
            let options: IOption[] = [];
            for (let group of operatorGroups) {
                options.push({
                    value: group.id,
                    descr: group.descr
                });
            }
            return {
                type: CLIENT_DATA_TYPE_SELECT,
                placeholder: __('SELECT_OPERATORS_GROUP_FOR_CONVERSTATION'),
                name: OPERATOR_GROUP_NAME,
                options,
                optgroup: [],
                descr: __('SELECT_OPERATORS_GROUP_FOR_CONVERSTATION')
            };
        }
    }
    return null;
});

let form = computed(() => {
    let needAddQuestionCategory = ChatTabStore.isNeedAddQuestionCategoryToFieldsList();

    return {
        ...(operatorGroupSelect.value ? {[OPERATOR_GROUP_NAME]: COLLECT_CONTACT_FIELD_REQUIRED} : {}),
        ...(needAddQuestionCategory ? {[QUESTION_CATEGORY_FIELD_NAME]: COLLECT_CONTACT_FIELD_REQUIRED} : {}),
        ...leadGen.value.startDialogFormConfig.collectContacts
    };
});

let pmForm = computed(() => {
    return leadGen.value.pmForm;
});

let textareaField = computed<ITextareaField>(() => {
    return {
        name: TEXTAREA_NAME,
        placeholder: pmForm.value.questionTextareaPlaceholder,
        type: CLIENT_DATA_TYPE_TEXTAREA,
        upload: pmForm.value.upload
    }
})

let fields = computed<Dictionary<IField>>(() => {
    return {
        ...ConfigStore.siteParams.value.formElements,
        [OPERATOR_GROUP_NAME]: operatorGroupSelect.value
    };
});

syncTextareaFromStorage();

watch(storageTextareaValue, () => syncTextareaFromStorage());
watch(modelTextareaValue, () => {
    if (isNeedToSyncText()) {
        ChatTabStore.setTextareaValue(modelTextareaValue.value);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(message))
      ? (_openBlock(), _createBlock(ChatMessage, {
          key: 0,
          class: "mb-4",
          message: _unref(message),
          "show-time": false,
          "show-date-if-needed": false,
          "message-props": {
                    margin: false
                }
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _createVNode(ChatForm, {
      modelValue: _unref(model).form,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).form) = $event)),
      form: _unref(form),
      fields: _unref(fields),
      button: _unref(__)('SEND'),
      "show-load": _unref(showLoad),
      onApply: send
    }, _createSlots({
      prepend: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ChatTextareaInput, {
            field: _unref(textareaField),
            modelValue: _unref(model).form[TEXTAREA_NAME],
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).form[TEXTAREA_NAME]) = $event)),
            "upload-is-listening": "",
            onUpload: onUpload
          }, null, 8, ["field", "modelValue"]),
          _createVNode(ChatAttachList, {
            class: "mt-2",
            attachments: _unref(model).attachments,
            "onUpdate:attachments": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).attachments) = $event))
          }, null, 8, ["attachments"])
        ])
      ]),
      _: 2
    }, [
      (_unref(hasChatHistory))
        ? {
            name: "append",
            fn: _withCtx(() => [
              _createVNode(ChatFormButton, {
                class: "float-right",
                round: "",
                onClick: cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" ← " + _toDisplayString(_unref(__)("TO_CHAT")), 1)
                ]),
                _: 1
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "form", "fields", "button", "show-load"])
  ]))
}
}

})